module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 90.b3ac6376.png";